import request from './request';

// 状态
export const getStatus = params => {
    return request({
        url: '/tashan/minions/getStatus',
        method: 'GET',
        params
    })
}

// 获取微信配置信息
export const getShare = params => {
    return request({
        url: '/index/wechat/share',
        method: 'GET',
        params
    })
}

// 抽奖
export const doLottery = params => {
    return request({
        url: '/tashan/minions/doLottery',
        method: 'GET',
        params
    })
}

// 抽奖确认
export const lotteryCallback= params => {
    return request({
        url: '/tashan/minions/lotteryCallback',
        method: 'GET',
        params
    })
}

// 提交信息
export const submitInfo = params => {
    return request({
        url: '/tashan/minions/submitInfo',
        method: 'POST',
        params
    })
}